"use strict";

AquaTechTheme.registerModule('collection-bundle', null, function() {
    AquaTechTheme.CollectionBundle = {
        $: null,
        $jsDebug: null,
        DEBUG: true,

        onDocReady: function() {
            this.$ = AquaTechTheme.$;
            var $ = this.$;

            this.initRecommendations();
        },

        initRecommendations: function () {
          var self = this;
          var $ = self.$;

          var $productPanels = $('.product-collection-bundle .recommend-product');
          $productPanels.each(function() {
            var $productPanel = $(this);

            var $addToCart = $productPanel.find('.add-to-cart .button');
            $addToCart.on('click', function(e) {
              e.preventDefault();
              self.addToCartSingle($(this));
            });

            var $selectToggle = $productPanel.find('.select-toggle');
            $selectToggle.on('click', function(e) {
              e.preventDefault();
              var $selectedProductPanel = $(this).closest('.recommend-product.recommended');
              self.toggleRecommendedSelect($selectedProductPanel);
            });
          });

          var $totalPanel = $('.product-collection-bundle .recommend-product.totals');
          var $addSelectedButton = $totalPanel.find('.add-to-cart .button');
          $addSelectedButton.on('click', function(e) {
            e.preventDefault();
            self.addToCartSelected($(this));
          });

          var $selectToggle = $totalPanel.find('.select-toggle');
          $selectToggle.on('click', function(e) {
            e.preventDefault();
            self.toggleSelectAll($(this));
          });

          self.watchVariations();
          self.watchCart();

          self.updateRecommendedTotals();
        },

        toggleRecommendedSelect: function($productPanel, setState) {
          var self = this;
          var $ = self.$;

          var state = $productPanel.attr('data-selected');
          var $stateToggle = $productPanel.find('.select-toggle');

          var newState = state == '' ? 'selected' : '';
          if (setState) {
            newState = setState;
          }

          if (newState == 'selected') {
            $productPanel.attr('data-selected', 'selected');
            $stateToggle.addClass('selected');
          } else {
            $productPanel.attr('data-selected', '');
            $stateToggle.removeClass('selected');
          }

          self.updateRecommendedTotals();
        },

        toggleSelectAll: function($panel) {
          var self = this;
          var $ = self.$;

          var $bundle = $selectToggle.closest('.product-recommend-bundle');
          var $productPanels = $bundle.find(".recommend-product.recommended");
          var hasSelections = false;
          var allSelected = true;
          $productPanels.each(function() {
              var $productPanel = $(this);
              if ($productPanel.attr('data-selected') !== 'selected') {
                allSelected = false;
              }
          });

          $productPanels.each(function() {
              var $productPanel = $(this);
              if (allSelected) {
                self.toggleRecommendSelect($productPanel, '');
              } else if ($productPanel.attr('data-selected') !== 'selected') {
                self.toggleRecommendSelect($productPanel, 'selected');
              }
          });
        },

        priceSymbol: function() {
          var priceSymbol = '';
          switch (window.Shopify.currency.active) {
            case 'AUD':
              priceSymbol = '$';
              break;
            case 'USD':
              priceSymbol = '$';
              break;
            case 'GBP':
              priceSymbol = '£';
              break;
            case 'EUR':
              priceSymbol = '€';
              break;
            default:
              priceSymbol = '';
          }
          return priceSymbol;
        },

        updateRecommendedTotals: function() {
          var self = this;
          var $ = self.$;

          var $bundle = $(".product-recommend-bundle");
          var $products = $bundle.find('.recommend-product.recommended');
          var $total = $bundle.find('.recommend-product.totals');
          var totalPrice = 0;
          var numSelected = 0;
          $products.each(function() {
            var $product = $(this);
            if ($product.attr('data-selected') == 'selected') {
              totalPrice += parseFloat($product.data('price'));
              numSelected++;
            }
          });
          totalPrice = totalPrice.toFixed(2);
          $total.find('.total .price').html(self.priceSymbol() + totalPrice);

          var $totalAddToCart = $total.find('.add-to-cart .button');
          if (numSelected > 0) {
            $totalAddToCart.html('Add selected to cart').removeClass('disabled');
          } else {
            $totalAddToCart.html('No selection').addClass('disabled');
          }
        },

        addToCartSingle: function($button) {
          var self = this;
          var $ = self.$;

          var $selectedProductPanel = $button.closest('.recommend-product.recommended');
          var variantId = $selectedProductPanel.attr('data-variant-id');

          var formData = {
            'items': [{
              'id': variantId,
              'quantity': 1
            }]
          };

          self.addToCartPost(formData, function() {
            self.addedSingleToCart($button);
          });
        },

        addedSingleToCart: function($addButton) {
          window.wetheme.toggleRightDrawer();
        },

        addToCartSelected: function($addAllButton) {
          var self = this;
          var $ = self.$;

          var $bundle = $addAllButton.closest('.product-recommend-bundle');
          var $selectedProducts = $bundle.find(".recommend-product.recommended[data-selected='selected']");

          var items = [];
          $selectedProducts.each(function() {
            var $selectedProductPanel = $(this);
            var variantId = $selectedProductPanel.attr('data-variant-id');
            items.push({
              'id': variantId,
              'quantity': 1
            });
          });

          var formData = {
            'items': items
          };

          self.addToCartPost(formData, function() {
            self.addedSelectionToCart($addAllButton);
          });
        },

        addedSelectionToCart: function($addAllButton) {
          var self = this;

          var $totals = $('.recommend-product.totals');

          $addAllButton.html('Added to cart');

          window.wetheme.toggleRightDrawer();
        },

        addToCartPost: function(formData, callback) {
          var self = this;

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            if (response.ok) {
              if (callback) {
                callback();
              }
              self.triggerCartUpdate();
            }
          })
          .catch((error) => {
            console.log('Error:', error);
          });
        },

        /* Watch for cart mutation: */
        watchCart: function() {
          document.documentElement.addEventListener('wetheme-cart-update', (event) => {
            console.log('Cart updated.');
            AquaTechTheme.CollectionBundle.updateRecommendationsCartState();
          });

          AquaTechTheme.CollectionBundle.updateRecommendationsCartState();
        },

        /* Trigger cart update event */
        triggerCartUpdate: function() {
          var self = this;
          var $ = self.$;

          $.ajax({
            url: "/cart?view=compare",
            type: 'GET',
            success: function(response) {
              var e = JSON.parse(response);
              window.wetheme.updateCartDrawer(e);
              var cartEvent = new CustomEvent("wetheme-cart-update", {
                  detail: {
                      cart: e
                  }
              });
              document.documentElement.dispatchEvent(cartEvent);

              console.log('Update Cart');
              window.THEME_CART_HOOK.fetchCart();
            },
            error: function(xhr, ajaxOptions, thrownError) {
              console.log(xhr.status + ' ' + thrownError);
            }
          });
        },

        fetchCart: async function() {
            try {
                const languageUrl = document.getElementById("PageContainer").dataset.languageUrl;
                const e = languageUrl && "/" != languageUrl ? languageUrl : "",
                    t = await window.fetch(`${e}/cart?view=compare`);
                t.ok;
                const n = await t.json();
                this.cart = n, n.attributes.gift_note && (this.giftNote = n.attributes.gift_note), this.theme.updateCartDrawer(n)
            } catch (e) {
                console.error("Unable to fetch cart: ", e)
            }
        },

        /* Watch for variation pick changes on product */
        watchVariations: function() {
          var self = this;
          var $ = self.$;

          var $formInputs = $("form#AddToCartForm .swatch input");
          $formInputs.on('change', function() {
            var $input = $(this);
            console.log('input change', $input.val());
            self.applyCurrentProductVariation();
          });

          self.applyCurrentProductVariation();
        },

        /* Update bundle display to reflect current variation */
        applyCurrentProductVariation: function() {
          var self = this;
          var $ = self.$;

          var currentVariantId = AquaTechTheme.getUrlParameter('variant');
          var $variantSpecs = $('.product-recommend-bundle .variant-prop');
          $variantSpecs.each(function() {
            var $vs = $(this);
            if ($vs.attr('data-variant-id') == currentVariantId) {
              var $bProd = $vs.closest('.recommend-product.recommended');
              $bProd.attr('data-variant-id', $vs.attr('data-variant-id'));
              $bProd.attr('data-price', $vs.attr('data-variant-price'));

              var $price = $bProd.find('.price .money .money');
              var fmtPrice = parseFloat($vs.attr('data-variant-price'));
              fmtPrice = self.priceSymbol() + fmtPrice.toFixed(2);
              $price.html(fmtPrice);
            }
          });

          self.updateRecommendationsCartState();
        },

        updateRecommendationsCartState: function() {
          var self = this;
          var $ = self.$;

          self.getCart(self.updateRecommendationsCartFetched);
        },

        /* Ajax Fetch cart contents */
        getCart: function(callback) {
          var self = this;
          var $ = self.$;

          $.ajax({
            url: "/cart.json",
            type: 'GET',
            success: function(response) {
              self.parseCart(response, callback);
            },
            error: function(xhr, ajaxOptions, thrownError) {
              console.log(xhr.status + ' ' + thrownError);
            }
          });
        },

        /* Extract product & variant ids from cart */
        parseCart: function(response, callback) {
          var self = this;

          self.cachedCartProducts = [];

          for (var ci = 0; ci < response.items.length; ci++) {
            var item = response.items[ci];
            self.cachedCartProducts[item.product_id] = {
              variant_id: item.variant_id,
              qty: item.quantity
            }
          }

          callback();
        },

        updateRecommendationsCartFetched: function() {
          var self = AquaTechTheme.CollectionBundle;
          var $ = self.$;

          var $products = $('.recommend-product.recommended');
          $products.each(function() {
            var $product = $(this);
            var $button = $product.find('.add-to-cart .button');
            $button.removeClass('disabled');
            $button.html('Add to cart');
          });

          for (var prodId in self.cachedCartProducts) {
            if (self.cachedCartProducts.hasOwnProperty(prodId)) {
              var variantId = self.cachedCartProducts[prodId].variant_id;
              var $matchRecommendation = $(".recommend-product.recommended[data-variant-id='" + variantId + "']");
              $matchRecommendation.addClass('in-cart');
              var $button = $matchRecommendation.find('.add-to-cart .button');
              $button.addClass('disabled');
              $button.html('In cart');
              $matchRecommendation.attr('data-selected', '');
              var $select = $matchRecommendation.find('.select-toggle');
              $select.removeClass('selected');
            }
          }

          self.updateRecommendedTotals();
        }
    };

    AquaTechTheme.$(function() { AquaTechTheme.CollectionBundle.onDocReady(); });
});